import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConfigService } from '../../core/services/config/config.service';
import { UtilityService } from '../../core/services/utility/utility.service';
import { PatientGoal } from '../models/patient-goal';

@Injectable({
  providedIn: 'root',
})
export class PatientGoalsService {
  private utilityService = inject(UtilityService);
  private configService = inject(ConfigService);
  private config = this.configService.config;

  endpoint = `${this.config.patientApiUrl}/v1/PatientPortal/PatientGoals`;

  getPatientGoals(patientId: number): Observable<PatientGoal[]> {
    const url = `${this.endpoint}?patientId=${patientId}`;
    return this.utilityService.getRequest<PatientGoal[]>(url);
  }

  getPatientGoalById(goalId: number, patientId: number): Observable<PatientGoal> {
    const url = `${this.endpoint}/${goalId}?patientId=${patientId}`;
    return this.utilityService.getRequest<PatientGoal>(url);
  }

  postPrintEvent(patientId: number, patientGoalId: number): Observable<void> {
    const url = `${this.endpoint}/${patientGoalId}/PrintEvent?patientId=${patientId}`;
    return this.utilityService.postRequest<void>(url, null, { skipGlobalError: true });
  }
}
